export const SharedRoomIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="31"
      height="25"
      viewBox="0 0 31 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.55487 24.4575C1.86487 24.4575 1.26663 24.2041 0.760125 23.6974C0.253375 23.1909 0 22.5926 0 21.9026V2.56387C0 1.87137 0.253375 1.271 0.760125 0.762749C1.26663 0.254249 1.86487 0 2.55487 0H27.8936C28.5861 0 29.1865 0.254249 29.6947 0.762749C30.2032 1.271 30.4575 1.87137 30.4575 2.56387V21.9026C30.4575 22.5926 30.2032 23.1909 29.6947 23.6974C29.1865 24.2041 28.5861 24.4575 27.8936 24.4575H2.55487ZM2.55487 11.1082H9.47625V2.56387H2.55487V11.1082ZM11.7262 11.1082H18.7223V2.56387H11.7262V11.1082ZM20.9722 11.1082H27.8936V2.56387H20.9722V11.1082ZM9.47625 21.9026V13.3582H2.55487V21.9026H9.47625ZM11.7262 21.9026H18.7223V13.3582H11.7262V21.9026ZM20.9722 21.9026H27.8936V13.3582H20.9722V21.9026Z"
        fill="currentColor"
      />
    </svg>
  );
};
